import assert from './assert'

const thumbnailsCDN = process.env.THUMBNAILS_CDN

assert(
  thumbnailsCDN,
  'Unable to find path to thumbnails cdn! THUMBNAILS_CDN was not found during build',
)

export const imageTypes = {
  FRONT: 'FRONT',
  LABEL: 'LABEL',
  BACK: 'BACK',
  LABEL_DETAIL: 'LABEL_DETAIL',
  CAP: 'CAP',
  BOTTLE360: 'BOTTLE360',
  ACCESSORIES360: 'ACCESSORIES360',
  BOX360: 'BOX360',
  EXTRA: 'EXTRA',
}

export const thumbnailSizes = {
  SMALL: '50',
  MEDIUM: '100',
  LARGE: '200',
}

function simpleJoinPaths(...paths) {
  return paths.reduce((acc, segment, index) => {
    if (!segment) {
      return acc
    }
    if (index === 0) {
      return acc + segment
    }
    return acc + '/' + segment.replace(/^\/|\/$/g, '')
  }, '')
}

export function getProductThumbnailURL(filename, size) {
  return simpleJoinPaths(thumbnailsCDN, size, 'JPEG', filename)
}

export function getDatoCmsThumbnail(url, size) {
  return `${url}?h=${size}`
}
